#import "../fragments/related-lead-fragment.graphql"

query GetRelatedLeads($changeLogId: ID!) {
    event(changeLogId: $changeLogId) {
        id
        payload {
            ... on Activity {
                id
                relatedLeads {
                    id
                    name
                    ... on Lead {
                        ...RelatedLeadFragment
                    }
                }
            }
            ... on Email {
                id
                emailRelatedLeads: relatedLeads {
                    edges {
                        isMapped
                        node {
                            ...RelatedLeadFragment
                        }
                    }
                }
            }
            ... on Chat {
                id
                relatedLeads {
                    id
                    name
                    ... on Lead {
                        ...RelatedLeadFragment
                    }
                }
            }
        }
    }
}
